/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: dropdown-Widget - Einzeilige Texteingabe
 *
 * Das dropdown-Widget bietet die Möglichkeit einen Wert aus einer Liste von Werten auszuwählen.
 * Die aktuelle Auswahl wird in einem Button angezeigt. Klickt man auf den Button erscheint die
 * Auswahlliste.
 * Die Steuerung des Widgets basiert auf folgender widget-Struktur:
 *
"fields": [
    {
        "id": "client",
        "length": 80,
        "label": "Client",
        "unitLabel": "",
        "description": "Client",
        "placeholder": "",
        "widget": "dropdown",
        "maxItems": 1,
        "visibleItems": 4,
        "group": null,
        "value": "",
        "enums": []
        "validation": null,
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im dropdown-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes (hier keine Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier keine Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "dropdown" belegt
 * maxItems      - Maximale Anzahl an auswählbaren Werten/Zeichen (hier immer mit 1 belegt)
 * visibleItems  - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktuell gültige Auswahl bzw. Wert der im Dropdown angezeigt wird
 * enums         - Alle Auswahlmöglichkeiten
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * state         - Zustand der Validierung (hier ohne Bedeutung)
 * message       - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field - field-Object
 * value - aktueller Wert
 * type  - input-type - wird an das input-Tag weitergeleitet
 * icon  - Bezeichnung des Icons, das rechts neben dem Eingabefeld erscheint.
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 * onKeyPress - callback-Funktion. Wird aufgerufen, wenn eine Taste gedrückt wurde
 * onBlur - callback-Funktion. Wird aufgerufen, wenn das Feld verlassen wird
 *
 */
import React from 'react';

const Dropdown = ({ field, value, onChange }) => {

    //console.log("Dropdown() field:", field);

    var dropdown = field.enums.map(function (data) {
        return (
            <option
                key={data.value}
                value={data.value}>
                {data.label}
            </option>)
    });

    return (

        <select
            className="bg-gray-200 appearance-none rounded h-12 w-full px-4 text-gray-700"
            id={field.id}
            disabled={field.disabled}
            value={value}
            onChange={(e) => onChange(e, e.target.value)}>
            {dropdown}
        </select>
    )
};

export default Dropdown